import $axios from '~/plugins/axios';

import { Api, CampaignSplit, GetCampaignSplitParams } from '~/api';
import { buildModule } from '../utils';
import { createDict, Dict } from '~/helpers';

const api = $axios as Api;

type LazyLoadingParams = Omit<GetCampaignSplitParams, 'limit' | 'offset'>;

export default buildModule()
	.withState({
		splitById: {} as Dict<CampaignSplit>,
		orderedIds: [] as number[],
		params: {} as LazyLoadingParams,
	})
	.withGetters({
		items: (state) => state.orderedIds.map(id => state.splitById[id]),
		byId: (state) => (id: number): CampaignSplit | null => state.splitById[id] ?? null,
	})
	.withMutations({
		RESET (state, params: LazyLoadingParams = {}) {
			state.params = params;
			state.orderedIds = [];
		},
		APPEND_SPLITS (state, splits: CampaignSplit[]) {
			state.splitById = { ...state.splitById, ...createDict(splits, ({ id }) => id) };
			state.orderedIds = Array.from(new Set([ ...state.orderedIds, ...splits.map(v => v.id) ]));
		},
		SET_SPLITS (state, splits: CampaignSplit[]) {
			state.splitById = { ...state.splitById, ...createDict(splits, ({ id }) => id) };
		},
	})
	.withActions({
		async getMore ({ state, commit }, limit: number | null = 20) {
			const params: GetCampaignSplitParams = { ...state.params, limit, offset: state.orderedIds.length };
			const { data } = await api.get('/campaign-split', { params });

			commit('APPEND_SPLITS', data.payload);
		},
		async prefetchSplits ({ commit }, splitIds: number[]) {
			const responses = await Promise.all(splitIds.map(id => api.get(`/campaign-split/${ id }`)));
			commit('SET_SPLITS', responses.map(resp => resp.data.payload as CampaignSplit));
		},
		resetParams ({ state, commit }, params: LazyLoadingParams = {}) {
			commit('RESET', { ...state.params, ...params });
		},
	});
